<template>
  <div>
  <b-button v-b-modal.add-tab-list variant="success" size="sm"><span><v-icon name="plus"></v-icon></span> Add tables</b-button>
  
  <b-modal ref="modal" id="add-tab-list" hide-footer centered title="Add New Tables">
    <b-form @submit.prevent="addTables">
      <b-form-group label="Titles:">
        <b-form-textarea
          @keydown.enter.prevent="addTabDelimiter"
          autofocus=""
          v-model.trim="$v.input.$model"
          :class="{ 'is-invalid': $v.input.$error }"
          :disabled="inProgress"
        />
        <b-form-invalid-feedback>Title is required</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
       style='display:none'
      >
        <b-form-checkbox v-model="createTable" :disabled="inProgress">
          <span>Create Tables</span>
        </b-form-checkbox>
      </b-form-group>
      <div>
        <b-button type="submit" variant="primary" :disabled="inProgress">
          <span>Save</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</div>
</template>

<script>

// validations
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import Icon from 'vue-awesome/components/Icon'

// let $ = window.$;
export default {
  mixins: [validationMixin],
  components: {
    'v-icon': Icon,
  },
  props: {
    tab: String
  },
  data(){
    return {
      input: null,
      title: null,
      template: null,
      createTable: true,
      inProgress: false,
    }
  },
  methods: {
    addTabDelimiter(){
      this.input = event.target.value + '\n'
    },
    addTables(){
      let tableTitles
      let re = '\n'
      if(this.input) tableTitles = this.input.split(/\r\n|\n|\r/)
     // console.log(tableTitles)
      tableTitles.forEach(title => this.save(title))
     // console.log(tableTitles)
    },
    async save(title) {
      // if (this.inProgress) return
      // this.$v.$touch()
      // if (this.$v.$invalid) return
      // this.inProgress = true
      console.log('save triggered')
      const currentTab = await new Promise(resolve => {
        const data = {
          title: title,
          template: this.template
        }
        db.tabs.create(data, newTabKey => {
          resolve(newTabKey)
        })
      })
      if (this.createTable) {
        const gridId = this.$sanitize(title)
        const gridData = {
          title: title,
          storageType: 'dashboard',
          source: this.$sanitize(title),
          tab: currentTab,
          filterVisible: null,
          overflow: 'height:auto',
          gsOptions: {
            x: 0,
            y: 0,
            w: 24,
            h: 18,
          },
        }

        await db.dataGrid.widget.createNew(gridData)
        eventBus.$emit('dataGridAdded', gridId)
      }

      this.title = null
      this.createTable = false
      this.inProgress = false

      this.$emit('onTabAdded', currentTab)
      if(this.$refs.modal) this.$refs.modal.hide()
      // this.$nextTick(() => {
      //   this.$v.$reset()
      // })
    },
  },
  validations: {
    input: {
      required,
    },
  },
}
</script>

<style lang="scss" scoped>

</style>